// Geometry for the prototype's smoothed sparklines (`smoothPath` / `sparkPaths`).

type Point = [number, number];

/** Catmull-Rom style cubic smoothing through the points (tension 0.19, as in the prototype). */
export function smoothPath(points: Point[]): string {
  const first = points[0];
  if (!first) return '';
  let d = `M${first[0].toFixed(1)},${first[1].toFixed(1)}`;
  const k = 0.19;
  for (let i = 0; i < points.length - 1; i++) {
    const p1 = points[i] as Point;
    const p0 = points[i - 1] ?? p1;
    const p2 = points[i + 1] as Point;
    const p3 = points[i + 2] ?? p2;
    const c1x = p1[0] + (p2[0] - p0[0]) * k;
    const c1y = p1[1] + (p2[1] - p0[1]) * k;
    const c2x = p2[0] - (p3[0] - p1[0]) * k;
    const c2y = p2[1] - (p3[1] - p1[1]) * k;
    d += ` C${c1x.toFixed(1)},${c1y.toFixed(1)} ${c2x.toFixed(1)},${c2y.toFixed(1)} ${p2[0].toFixed(1)},${p2[1].toFixed(1)}`;
  }
  return d;
}

/** Line and filled-area paths for a series scaled into a `width`×`height` box. */
export function sparkPaths(series: number[], width: number, height: number) {
  if (series.length < 2) return { line: '', area: '' };
  const min = Math.min(...series);
  const max = Math.max(...series);
  const span = max - min || 1;
  const points: Point[] = series.map((v, i) => [
    (i / (series.length - 1)) * width,
    height - 2 - ((v - min) / span) * (height - 4),
  ]);
  const line = smoothPath(points);
  const last = points[points.length - 1] as Point;
  const first = points[0] as Point;
  return {
    line,
    area: `${line} L${last[0].toFixed(1)},${height} L${first[0].toFixed(1)},${height} Z`,
  };
}
